import React from 'react';

/* Modal ------------------------------------------------------------ */
export function Modal({ isOpen, onClose, title, children, size = '' }) {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${size ? `modal-${size}` : ''}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}

/* FormGroup -------------------------------------------------------- */
export function FormGroup({ label, required, children }) {
  return (
    <div className="form-group">
      {label && (
        <label className="form-label">
          {label}{required && <span className="required">*</span>}
        </label>
      )}
      {children}
    </div>
  );
}

/* Input ------------------------------------------------------------ */
export function Input({ ...props }) {
  return <input className="input" {...props} />;
}

/* Select ----------------------------------------------------------- */
export function Select({ children, ...props }) {
  return <select className="input" {...props}>{children}</select>;
}

/* Textarea --------------------------------------------------------- */
export function Textarea({ ...props }) {
  return <textarea className="input" rows={3} {...props} />;
}

/* Badge ------------------------------------------------------------ */
const BADGE_MAP = {
  // status genéricos
  ativo: 'success', active: 'success',
  inativo: 'danger', inactive: 'danger',
  // assets
  disponivel: 'success', disponível: 'success',
  locado: 'primary', alugado: 'primary',
  manutencao: 'warning', manutenção: 'warning', manutencão: 'warning',
  // contratos / financeiro
  vigente: 'success', pago: 'success', recebido: 'success',
  pendente: 'warning', aberto: 'warning',
  vencido: 'danger', cancelado: 'danger', inadimplente: 'danger',
  encerrado: 'secondary',
  // logística
  agendado: 'primary', entregue: 'success', coletado: 'success',
  em_andamento: 'warning',
  // roles
  admin: 'primary', manager: 'info', operator: 'secondary', viewer: 'secondary',
  superadmin: 'danger',
};

export function Badge({ status = '', children }) {
  const key = (status || '').toLowerCase().replace(/\s+/g, '_');
  const variant = BADGE_MAP[key] || 'secondary';
  return <span className={`badge badge-${variant}`}>{children || status}</span>;
}

/* Alert ------------------------------------------------------------ */
export function Alert({ type = 'info', children }) {
  return <div className={`alert alert-${type}`}>{children}</div>;
}

/* Loading ---------------------------------------------------------- */
export function Loading() {
  return (
    <div className="loading-container">
      <div className="spinner" />
    </div>
  );
}

/* EmptyState ------------------------------------------------------- */
export function EmptyState({ title = 'Nenhum registro encontrado', description, action }) {
  return (
    <div className="empty-state">
      <div className="empty-icon">📭</div>
      <h4 className="empty-title">{title}</h4>
      {description && <p className="empty-description">{description}</p>}
      {action && <div className="empty-action">{action}</div>}
    </div>
  );
}

/* PageHeader ------------------------------------------------------- */
export function PageHeader({ title, subtitle, action, children }) {
  return (
    <div className="page-header">
      <div className="page-header-info">
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      <div className="page-header-actions">
        {action}
        {children}
      </div>
    </div>
  );
}

/* StatCard --------------------------------------------------------- */
export function StatCard({ icon, value, label, color = '#0ea5e9', bg = '#e0f2fe' }) {
  return (
    <div className="stat-card">
      {icon && (
        <div className="stat-icon" style={{ background: bg, color }}>
          {icon}
        </div>
      )}
      <div className="stat-info">
        <div className="stat-value" style={{ color }}>{value}</div>
        <div className="stat-label">{label}</div>
      </div>
    </div>
  );
}

/* Table ------------------------------------------------------------ */
export function Table({ columns = [], data = [], loading }) {
  if (loading) return <Loading />;
  return (
    <div className="table-wrapper">
      <table className="table">
        <thead>
          <tr>
            {columns.map(col => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={row.id || i}>
              {columns.map(col => (
                <td key={col.key}>
                  {col.render ? col.render(row) : (row[col.key] ?? '—')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
